import whenWindowLoaded from '@netc/when-window-loaded';
import { tns } from 'tiny-slider/src/tiny-slider';
class Card {
    constructor(card) {
        this.isOpen = false;
        this.clearedHeights = false;
        this.updateHeight = (clear) => {
            if (this.offer === null) {
                return;
            }
            if (clear === true) {
                this.offer.style.height = '';
                this.offer.style.flex = '';
                return;
            }
            this.offer.style.height = `${this.offer.clientHeight}px`;
            this.offer.style.flex = '0 0 auto';
            this.card.style.marginBottom = 'auto';
        };
        this.render = () => {
            if (this.footer !== null) {
                if (this.isOpen) {
                    this.footer.classList.add('active');
                }
                else {
                    this.footer.classList.remove('active');
                }
            }
        };
        this.card = card;
        this.carouselContainer = card.querySelector('.js-promotion-carousel');
        this.carouselNav = card.querySelector('.js-promotion-carousel-nav');
        this.offer = card.querySelector('.js-promotion-card__offer');
        this.footer = card.querySelector('.js-promotion-card__footer');
        this.footerTrigger = card.querySelector('.js-promotion-card__footer-trigger');
        this.footerContent = card.querySelector('.js-promotion-card__footer-content');
        this.slider = null;
        // bind resize to clear heights
        window.addEventListener('resize', () => {
            if (this.clearedHeights === true) {
                return;
            }
            this.updateHeight(true);
            this.clearedHeights = true;
        });
        // Bind click event
        if (this.footer !== null && this.footerContent !== null && this.offer !== null) {
            this.footerTrigger?.addEventListener('click', () => {
                this.isOpen = !this.isOpen;
                // Update class on next render
                requestAnimationFrame(this.render.bind(this));
            });
        }
        // set initial content heights
        this.updateHeight();
        // do initial render
        requestAnimationFrame(this.render.bind(this));
        if (this.carouselContainer === null || this.carouselNav === null) {
            return;
        }
        this.slider = tns({
            container: this.carouselContainer,
            speed: 500,
            mode: 'gallery',
            controls: false,
            nav: true,
            navContainer: this.carouselNav,
        });
        this.slider.play();
    }
}
function initialise() {
    const cardElements = Array.from(document.querySelectorAll('.js-promotion-card'));
    if (cardElements.length === 0) {
        return;
    }
    const cards = [];
    for (const card of cardElements) {
        cards.push(new Card(card));
    }
}
whenWindowLoaded().then(initialise);
